module.exports = __webpack_public_path__ + "img/lg_ring_r_s_null_0.c33610cc.png";